import config from '../config';

const BASE_URL = config.apiUrl;

export const api = {
    // baseURL defined below
    /**
     * Perform a generic request; convenience helpers (.get/.post) are added below.
     */
    baseURL: BASE_URL,

    async request(endpoint, options = {}) {
        const url = `${this.baseURL}${endpoint}`;
        console.log(`Making API request to: ${url}`, { options });
        const token = localStorage.getItem('auth_token');

        const defaultOptions = {
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : '',
            }
        };

        const mergedOptions = {
            ...defaultOptions,
            ...options,
            headers: {
                ...defaultOptions.headers,
                ...options.headers
            }
        };

        try {
            const response = await fetch(url, mergedOptions);
            console.log(`Response status:`, response.status);

            if (!response.ok) {
                const errorText = await response.text();
                console.error('Error response:', errorText);
                
                try {
                    const errorData = JSON.parse(errorText);
                    throw new Error(errorData.error || errorData.message || `Request failed with status: ${response.status}`);
                } catch (e) {
                    throw new Error(`Request failed with status ${response.status}: ${errorText || 'No error details available'}`);
                }
            }

            // Handle different response types.
            if (mergedOptions.responseType === 'blob') {
                const blob = await response.blob();
                console.log('API response blob (size)', blob.size);
                const headersObj = {}; // return { data: blob };
                response.headers.forEach((v, k) => { headersObj[k.toLowerCase()] = v; });
                return { data: blob, headers: headersObj };
            }

            const contentType = response.headers.get('content-type') || '';
            // If JSON, parse normally; otherwise return text.
            if (contentType.includes('application/json')) {
                const jsonData = await response.json();
                console.log('API response data:', jsonData);
                return jsonData;
            }
            const textData = await response.text();
            console.log('API response text:', textData.slice(0, 200));
            return textData;
        } catch (error) {
            console.error('API request failed:', {
                url,
                options: mergedOptions,
                error: error.message,
                stack: error.stack
            });
            throw error;
        }
    },
    /**
     * Convenience wrapper for GET requests.
     */
    async get(endpoint, options = {}) {
        return this.request(endpoint, { ...options, method: 'GET' });
    },
    /**
     * Convenience wrapper for POST requests.
     */
    async post(endpoint, body = null, options = {}) {
        const opts = { ...options, method: 'POST' };
        if (body !== null) {
            opts.body = typeof body === 'string' ? body : JSON.stringify(body);
        }
        return this.request(endpoint, opts);
    }
};

export const pauseAllSessions = () => api.request('/api/sessions/pause_all', { method: 'POST' });
export const resumeAllSessions = () => api.request('/api/sessions/resume_all', { method: 'POST' });

export default api;